import Big from 'big.js'

import { MARKET_MAP } from './currency-patterns'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const currencyData = require('./currencies.json')

class LhFormatCurrency {
  static formatCents(amount: number, currency: string, market: string): string {
    // using exponent values from ruby-money gem,
    // use puts Money::Currency.table.map
    // { |k, v| [k, {exponent: Money::Currency.new(k).exponent }]}.to_h.to_json
    // to generate currencies.json

    const amountBigDecimal = new Big(amount).div(
      new Big(10 ** currencyData[currency.toLowerCase()].exponent),
    )

    return this.formatBigByPattern(
      amountBigDecimal,
      currency,
      this.determinePattern(market),
    )
  }

  static formatBigByPattern(amount: Big, currency: string, pattern: string): string {
    const options = pattern.split('/')

    const mask = options[0]
    const groupingCharacter = options[1]
    const decimalCharacter = options[2]
    const positionCurrencyFirst = options[3] === 'left'

    const useGrouping = mask[1] === ','
    const fractionDigits = this.determineFractionDigits(amount, mask)

    let formattedNumber = Intl.NumberFormat('en-US', {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
      useGrouping,
    }).format(amount as unknown as number)

    formattedNumber = formattedNumber
      .replace(/,/g, '__GROUPING__')
      .replace(/\./g, '__DECIMAL__')

    formattedNumber = formattedNumber
      .replace(/__GROUPING__/g, groupingCharacter)
      .replace(/__DECIMAL__/g, decimalCharacter)

    if (positionCurrencyFirst) {
      return `${currency} ${formattedNumber}`
    }
    return `${formattedNumber} ${currency}`
  }

  static determineFractionDigits(amount: Big, mask: string): number {
    const decimals = mask.split('.')[1] || ''
    const useDecimals = decimals.length > 0
    const numberOfDecimalDigits = decimals.length
    const decimalsAreOptional = decimals === '#'.repeat(decimals.length)

    if (useDecimals) {
      if (decimalsAreOptional && amount.round(0).eq(amount)) {
        return 0
      }

      return numberOfDecimalDigits
    }

    return 0
  }

  static determinePattern(market: string): string {
    market = (market || '').toUpperCase()
    return MARKET_MAP[market] || MARKET_MAP.XX
  }
}

export default LhFormatCurrency
